// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "60fc0cda6befc22ad46a7e3ccb6f1482d18135f6/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};